import React from 'react';
import {Link} from 'react-router-dom';

const NotFound = () =>
  <div className="d-flex flex-row align-items-center">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-12 text-center">
                <span className="display-1 d-block">403</span>
                <div className="mb-4 lead">You are not authorized to access this page.</div>
                <Link className='btn btn-link' to="/">Back to Home</Link>
            </div>
        </div>
    </div>
  </div>

export default NotFound;


// WEBPACK FOOTER //
// ./src/shared/javascripts/components/NotAuthorized.jsx